import { z } from 'zod'
import { Model } from '../../_kernel/architecture'

export type PropertySources = (typeof ALLOWED_SOURCES)[number]

export const ALLOWED_SOURCES = ['hotelsSeen', 'recommended', 'visited', 'results'] as const

export const PropertySourceValidation = z.object({
  value: z.enum(ALLOWED_SOURCES).optional(),
})

export class PropertySource extends Model {
  static create({ value }: z.infer<typeof PropertySourceValidation>) {
    PropertySourceValidation.parse({ value })
    return new PropertySource(value)
  }

  static fromJSON(json?: Partial<ReturnType<PropertySource['toJSON']>>) {
    if (!json?.value) {
      return PropertySource.empty()
    }
    return PropertySource.create({ value: json.value })
  }

  static empty() {
    return new PropertySource()
  }

  static results() {
    return PropertySource.create({ value: 'results' })
  }

  constructor(private readonly _value?: PropertySources) {
    super()
  }

  isResults() {
    return this._value === 'results'
  }

  isVisited() {
    return this._value === 'visited'
  }

  isHotelsSeen() {
    return this._value === 'hotelsSeen'
  }

  isNotHotelsSeen() {
    return this._value !== 'hotelsSeen'
  }

  isNotVisited() {
    return this._value !== 'visited'
  }

  toJSON() {
    return {
      value: this._value,
    }
  }
}
